<template>
	<div class="main text-type-standart main-cursor-norm">
		<div v-if="preloader" class="d-flex d-flex-j-c">
			<div ref="icon__preloader" id="icon__preloader" class="main--preloader">
				<city id="icon__city" class="main--preloader-city"></city>
			</div>
		</div>
    <transition name="bounce">
      <div
        ref="services"
        v-show="services"
        class="d-flex d-flex-column d-flex-a-c d-flex-j-c main--services services"
        v-hammer:pan="cardMove"
        v-hammer:panend="cardStart">
      <div ref="servicesEl" class="services--top d-flex d-flex-j-c d-flex-a-c">
        <div @click="strelkaMinus" class="services--strelka services--phoneNone services--strelka-left main-cursor-point">
          <icon-base
            width="100%"
            height="100%"
            ViewWidth="31"
            ViewHeight="31"
            class="services--left"
          ><icon-arrow></icon-arrow>
          </icon-base>
        </div>
        <transition name="bounce">
          <div id="bounce--card" v-show="selected==0" class="services--element services-theme-color-base">
            <div @click="unvisibleServices" class="services--close  main-cursor-point">
              <icon-base
                width="100%"
                height="100%"
                ViewWidth="31"
                ViewHeight="31"
                class="services--left"
              ><icon-close></icon-close>
              </icon-base>
            </div>
            <div class="services--iconCloud">
              <IconBase
                width="100%"
                height="100%"
                ViewWidth="512"
                ViewHeight="512">
                <icon-tap
                  ref="iconTap"
                ></icon-tap>
              </IconBase>
            </div>
            <div class="services--text text-type-big text-size-l text-align-center">
              Смахивайте карточки налево и направо или нажимайте кнопки
            </div>
          </div>
        </transition>
        <transition name="bounce">
          <div id="bounce--card" v-show="selected==1" class="services--element services-theme-color-base">
            <div @click="unvisibleServices" class="services--close  main-cursor-point">
              <icon-base
                width="100%"
                height="100%"
                ViewWidth="31"
                ViewHeight="31"
                class="services--left"
              ><icon-close></icon-close>
              </icon-base>
            </div>
            <div class="services--iconCloud">
              <IconBase
                width="100%"
                height="100%"
                ViewWidth="512"
                ViewHeight="512">
                <icon-factory
                  ref="iconFactory"
                ></icon-factory>
              </IconBase>
            </div>
            <div class="services--text text-type-big text-size-l text-align-center">
              Разработка систем управления предприятием
            </div>
          </div>
        </transition>
        <transition name="bounce">
          <div id="bounce--card" v-show="selected==2" class="services--element services-theme-color-base">
            <div @click="unvisibleServices" class="services--close  main-cursor-point">
              <icon-base
                width="100%"
                height="100%"
                ViewWidth="31"
                ViewHeight="31"
                class="services--left"
              ><icon-close></icon-close>
              </icon-base>
            </div>
            <div class="services--iconCloud">
              <IconBase
                width="100%"
                height="100%"
                ViewWidth="512"
                ViewHeight="512">
                <icon-cloud
                  ref="iconCloud"
                ></icon-cloud>
              </IconBase>
            </div>
            <div class="services--text text-type-big text-size-l text-align-center">
              Разработка облачных сервисов
            </div>
          </div>
        </transition>
        <transition name="bounce">
          <div id="bounce--card" v-show="selected==3" class="services--element services-theme-color-base">
            <div @click="unvisibleServices" class="services--close  main-cursor-point">
              <icon-base
                width="100%"
                height="100%"
                ViewWidth="31"
                ViewHeight="31"
                class="services--left"
              ><icon-close></icon-close>
              </icon-base>
            </div>
            <div class="services--iconCloud">
              <IconBase
                width="100%"
                height="100%"
                ViewWidth="512"
                ViewHeight="512">
                <icon-phone
                  ref="iconPhone"
                ></icon-phone>
              </IconBase>
            </div>
            <div class="services--text text-type-big text-size-l text-align-center">
              Разработка мобильных приложений
            </div>
          </div>
        </transition>
        <transition name="bounce">
          <div id="bounce--card" v-show="selected==4" class="services--element services-theme-color-base">
            <div @click="unvisibleServices" class="services--close  main-cursor-point">
              <icon-base
                width="100%"
                height="100%"
                ViewWidth="31"
                ViewHeight="31"
                class="services--left"
              ><icon-close></icon-close>
              </icon-base>
            </div>
            <div class="services--iconCloud">
              <IconBase
                width="100%"
                height="100%"
                ViewWidth="512"
                ViewHeight="512">
                <icon-accounting
                ref="iconAcc"
                ></icon-accounting>
              </IconBase>
            </div>
            <div class="services--text text-type-big text-size-l text-align-center">
              Разработка систем учета
            </div>
          </div>
        </transition>
        <transition name="bounce" >
          <div id="bounce--card" v-show="selected==5" class="services--element services-theme-color-base">
            <div @click="unvisibleServices" class="services--close  main-cursor-point">
              <icon-base
                width="100%"
                height="100%"
                ViewWidth="31"
                ViewHeight="31"
                class="services--left"
              ><icon-close></icon-close>
              </icon-base>
            </div>
            <div class="services--iconCloud">
              <IconBase
                width="100%"
                height="100%"
                ViewWidth="63"
                ViewHeight="63">
                <icon-file
                  ref="iconFile"
                ></icon-file>
              </IconBase>
            </div>
            <div class="services--text text-type-big text-size-l text-align-center">
              Разработка систем документооборота
            </div>
          </div>
        </transition>
        <div @click="strelkaPlus" class="services--strelka services--phoneNone services--strelka-right main-cursor-point">
          <icon-base
            width="100%"
            height="100%"
            ViewWidth="31"
            ViewHeight="31"
            class="services--right"
          ><icon-arrow></icon-arrow>
          </icon-base>
        </div>
		  </div>
      <div v-show="!touchDevice" ref="bottomServices" class="services--bottom d-flex d-flex-j-c">
        <div @click="strelkaMinus" class="services--strelka services--strelka-left main-cursor-point">
          <icon-base
            width="100%"
            height="100%"
            ViewWidth="31"
            ViewHeight="31"
            class="services--left"
          ><icon-arrow></icon-arrow>
          </icon-base>
        </div>
        <div @click="strelkaPlus" class="services--strelka services--strelka-right main-cursor-point">
          <icon-base
            width="100%"
            height="100%"
            ViewWidth="31"
            ViewHeight="31"
            class="services--right"
          ><icon-arrow></icon-arrow>
          </icon-base>
        </div>
      </div>
    </div>
    </transition>
		<transition name="bounce">
			<div ref="formModal" v-show="form" class="form-modal services d-flex d-flex-j-c d-flex-a-c">
				<form ref="form">
					<div class="form services--element services-theme-color-base">
						<div @click="unvisibleForm" class="services--close  main-cursor-point">
							<icon-base
								width="100%"
								height="100%"
								ViewWidth="31"
								ViewHeight="31"
								class="services--left"
							><icon-close></icon-close>
							</icon-base>
						</div>
						<div class="form--banner ">
							<div class="form--icon">
								<IconBase
									width="100%"
									height="100%"
									ViewWidth="512"
									ViewHeight="512">
									<icon-telephone>
									</icon-telephone>
								</IconBase>
							</div>
							<div
								v-if="!dataSuccess && !dataError"
								class="form--text text-type-big text-size-l text-align-start"
							>
								Оставьте заявку и мы вам перезвоним
							</div>
							<div
								v-if="dataSuccess"
								class="form--text text-type-big text-size-l text-align-start"
							>
								Заявка успешно создана
							</div>
							<div
								v-if="dataError"
								class="form--text text-type-big text-size-l text-align-start"
							>
								Извините, не удалось создать заявку :(((
							</div>
						</div>
						<div v-if="!dataSuccess && !dataError" class="form--group">
							<input
								@blur="$v.formName.$touch()"
								type="text"
								class="form--input text-size-m main-cursor-point"
								v-model="formName"
								placeholder="Например: Денис"
							/>
							<span class="highlight"></span>
							<span
								:class="{'bar-success': !$v.formName.$error, 'bar-error': $v.formName.$error}"
								class="bar">
							</span>
							<label class="form--label text-size-m">Ваше имя</label>
							<div class="form--error">
								<label
									v-if="!$v.formName.required && $v.formName.$dirty"
									class="form--labelError text-size-s">*Это поле обязательно
								</label>
								<label
									v-if="!$v.formName.maxLength && $v.formName.$dirty"
									class="form--labelError text-size-s">Слишком много букв
								</label>
							</div>
						</div>
						<div v-if="!dataSuccess && !dataError" class="form--group">
							<masked-input
								@blur="$v.formPhone.$touch()"
								v-model="formPhone"
								type="text"
								name="phone"
								class="form--input text-size-m main-cursor-point"
								:mask="[/\d/, /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]"
								:guide="false"
								:keepCharPositions="false"
								placeholder="89501101101"
							></masked-input>
							<span class="highlight"></span>
							<span
								:class="{'bar-success': !$v.formPhone.$error, 'bar-error': $v.formPhone.$error}"
								class="bar">
							</span>
							<label class="form--label text-size-m">Ваш телефон</label>
							<div class="form--error">
								<label
									v-if="!$v.formPhone.minLength && $v.formPhone.$dirty"
									class="form--labelError text-size-s"
								>Проверьте правильность введенного номера</label>
								<label
									v-if="!$v.formPhone.required && $v.formPhone.$dirty"
									class="form--labelError text-size-s"
								>*Поле "Телефон" обязательно</label>
							</div>
						</div>
						<div v-if="!dataSuccess && !dataError" class="form--group">
							<masked-input
								@blur="$v.formEmail.$touch()"
								v-model="formEmail"
								type="text"
								name="phone"
								class="form--input text-size-m main-cursor-point"
								:mask="mask"
								:guide="true"
								placeholder="example@gmail.com">
							</masked-input>
							<span class="highlight"></span>
							<span :class="{'bar-success': !$v.formEmail.$error, 'bar-error': $v.formEmail.$error}" class="bar"></span>
							<label class="form--label text-size-m">Ваш Email</label>
							<div class="form--error">
							<label
								v-if="!$v.formEmail.required && $v.formEmail.$dirty"
								class="form--labelError text-size-s"
							>*Поле "Email" обязательно</label>
							<label
								v-if="!$v.formEmail.email"
								class="form--labelError text-size-s"
							>Ошибка. Пример "example@gmail.com"</label>
							</div>
						</div>
						<div v-if="!dataSuccess && !dataError" class="form--button text-size-m main-cursor-point" @click="onSumbit" >отправить</div>
					</div>
				</form>
			</div>
		</transition>
		<transition name="bounce">
		<div v-if="moneyFrom" class="form-modal services d-flex d-flex-j-c d-flex-a-c">
			<form>
				<div class="form services--element services-theme-color-base">
					<div @click="unvisibleMoney" class="services--close  main-cursor-point">
						<icon-base
							width="100%"
							height="100%"
							ViewWidth="31"
							ViewHeight="31"
							class="services--left"
						><icon-close></icon-close>
						</icon-base>
					</div>
					<div class="form--banner ">
						<div class="form--icon">
							<IconBase
									width="100%"
									height="100%"
									ViewWidth="58"
									ViewHeight="58">
								<icon-dollar
								></icon-dollar>
							</IconBase>
						</div>
						<div class="form--text text-type-big text-size-l text-align-start">
							Стоимость обговаривается индивидуально
						</div>
					</div>
					<div @click="unvisibleMoney" class="form--button text-size-m main-cursor-point"> Понятно </div>
				</div>
			</form>
		</div>
	</transition>
		<div class="main--real d-flex d-flex-column d-flex-j-a">
			<div class="d-flex d-flex-j-c " v-bind:class="{ 'main--blur': services}">
				<div class="main--gluh">
					<div class="gluh--top office--top office-color-bright"></div>
					<div class="gluh--bottom office--bottom office-color-white"></div>
				</div>
				<div ref="mainBox" class="main--box">
					<div class="box ">
						<div class="box--content">
							<div class="office">
								<div class="office--top office-color-bright">
									<div class="office--element office-pos-abs office-pos-abs-center office-main-5 office--money ">
										<div class="money--black">
										</div>
										<icon-base
											width="100%"
											height="100%"
											ViewWidth="689"
											ViewHeight="756"
										><icon-money
											ref="money"
										></icon-money></icon-base>
									</div>
									<div class="office--element office-pos-abs office--logo ">
										<div class="office--logo-child logo">
											<img src="../resources/img/logo.png" class="img--logo main-cursor-point">
										</div>
									</div>
									<div @click="visibleServices" class="office--element office-pos-abs office-main-2 office--board">
										<div class="office--board-child board">
											<icon-base
												width="100%"
												height="100%"
												ViewWidth="587"
												ViewHeight="357"
												class="main-cursor-point"
											><icon-board /></icon-base>
										</div>
									</div>
									<div
										@click="crashLamp"
										@mouseover="visibleLamp"
										@mouseleave="unvisible"
										class="office--element office--nasadkalamp office-pos-abs office-pos-abs-center office-main-5 main-cursor-point"
									>
									</div>
									<div class="office--element office-pos-abs office-pos-abs-center office-main-4 office--lamp">
										<div class="office--lamp-child lamp">
											<icon-base
												width="100%"
												height="100%"
												ViewWidth="1920"
												ViewHeight="2700"
											><icon-lamp
												ref="lamp"
												:select="boolLamp"
											/></icon-base>
										</div>
									</div>
									<div class="office--element office-pos-abs office-main-2 office-pos-abs-center office--monitor">
										<div class="office--monitor-child monitor">
											<icon-base
												width="100%"
												height="100%"
												ViewWidth="61"
												ViewHeight="61"
											>
												<icon-imac></icon-imac>
											</icon-base>
										</div>
									</div>
									<div class="office--element office-pos-abs office--radio">
										<radio-anim class="main-cursor-point">
										</radio-anim>
									</div>
									<div class="office--element office-pos-abs office-main-2 office--tea">
										<div @click="crashTea"  class="office--tea-child tea">
											<icon-base
												width="100%"
												height="100%"
												ViewWidth="306"
												ViewHeight="1230"
											><icon-tea
												ref="tea"
												:select="boolLamp"
												class="main-cursor-point"
											/></icon-base>
										</div>
									</div>
									<div class="office--element office-pos-abs office--smoke">
										<div class="office--smoke-child smoke">
											<template name="fade">
												<icon-base
													v-if="isHidden"
													width="100%"
													height="100%"
													ViewWidth="600"
													ViewHeight="876"
												><icon-smoke /></icon-base>
											</template>
										</div>
									</div>
									<div class="office--element office-pos-abs office-main-3 office-pos-abs-center office--table">
										<div class="office--table-child table">
											<icon-base
												width="100%"
												height="100%"
												ViewWidth="664"
												ViewHeight="611"
											><icon-table /></icon-base>
										</div>
									</div>
									<div class="office--element office-pos-abs office-main-1 office--avatar">
										<img class="office--avatar-child avatar" src="../resources/png/avatar.png" alt="">
									</div>
									<div class="office--element office-pos-abs office-main-1 office--cactus">
										<div class="office--cactus-child cactus">
											<icon-base
												width="100%"
												height="100%"
												ViewWidth="567"
												ViewHeight="293"
											>
												<icon-cactus class="main-cursor-point"></icon-cactus>
											</icon-base>
										</div>
									</div>
								</div>
								<div class="office--bottom office-color-white"> </div>
							</div>
						</div>
					</div>
				</div>
				<div class="main--gluh">
					<div class="gluh--top office--top office-color-bright"></div>
					<div class="gluh--bottom office--bottom office-color-white"></div>
				</div>
			</div>
			<div class="main--contact contact" v-bind:class="{ 'main--blur': services}">
				<div class="contact--group">
					<div class="contact--man d-flex d-flex-j-c d-flex-a-s">
						<div class="contact--circle">
							<div class="contact--man-child man">
								<icon-base
									width="100%"
									height="100%"
									ViewWidth="30"
									ViewHeight="40"
								><icon-head-man
									ref="head"
								></icon-head-man></icon-base>
							</div>
						</div>
					</div>
					<div class="contact--text">
						<div class="contact--null">
						</div>
						<div class="text text-color-white text-size-m contact--text-top">
							Привет, наша компания занимается разработкой систем управления предприятием,
							разработкой облачных сервисов, мобильных приложений, систем учета и
							систем документооборота.
						</div>
						<div class="contact--question contact--text-bot d-flex d-flex-j-c d-flex-a-c">
							<div @click="visibleServices" class="text text-color-white text-align-center text-size-m contact--button button main-cursor-point">
								Какие задачи вы решаете ?
							</div>
							<div @click="visibleMoney" class="text text-color-white text-align-center text-size-m contact--button button main-cursor-point">
								Какова стоимость ваших услуг ?
							</div>
							<div @click="visibleForm" class="text text-color-white text-align-center text-size-m contact--button button main-cursor-point">
								Как связаться с вами ?
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
	import { TweenMax, TimelineLite, Power2} from 'gsap'
	import MaskedInput from 'vue-text-mask'
	import emailMask from 'text-mask-addons/dist/emailMask'
	import axios from 'axios'

	import IconBase from './icon/IconBase.vue'
	import IconImac from './icon/IconImac.vue'
	import IconTable from './icon/IconTable.vue'
	import IconBoard from './icon/IconBoard.vue'
	import IconLamp from './icon/IconLamp.vue'
	import IconCactus from './icon/IconCactus.vue'
	import IconHeadMan from './icon/IconHeadMan.vue'
	import IconSmoke from './icon/IconSmoke.vue'
	import IconMoney from './icon/IconMoney.vue'
	import iconTea from './icon/iconTea.vue'
	import IconFactory from './icon/IconFactory.vue'
	import IconCloud from './icon/IconCloud.vue'
	import IconPhone from './icon/IconPhone.vue'
	import IconAccounting from './icon/IconAccounting'
	import IconFile from './icon/IconFile.vue'
	import IconArrow from './icon/IconArrow.vue'
	import IconClose from './icon/IconClose.vue'
	import City from './City.vue'
	import IconTap from './icon/IconTap'
	import iconTelephone from './icon/iconTelephone.vue'
	import iconDollar from './icon/iconDollar.vue'

	import RadioAnim from './iconAmination/RadioAnim.vue'

	export default {

		data: function() {
			return {
				isHidden: true,
				isHiddenLamp: false,
				lamp: undefined,
				money: undefined,
				tea: undefined,
				head: undefined,
				selected: 1,
				services: false,

				widthDevice: 0,
				heightDevice: 0,

				centerX: 0,
				leftGran: 0,
				rightGran: 0,

				cactusKill: false,

				preloader: true,

				form: false,
				moneyFrom: false,

				x: 0,
				y: 0,

				formName: '',
				formEmail: '',
				formPhone: '',

				mask: emailMask,

				dataSuccess: false,
				dataError: false
			}
		},
		mounted() {
      window.addEventListener('keydown', this.keyUnvisibleServices)
      window.addEventListener('resize', this.windowSize)
      this.windowSize();

			this.lamp = this.$refs.lamp;
			this.head = this.$refs.head;
			this.money = this.$refs.money;
			this.tea = this.$refs.tea;

			if (this.isTouchDevice()) {
				this.selected = 0;
        this.unvisibleButtonServ()
			}

			this.cardAnimStartAll();
			this.cardAnimPauseAll();
			document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.poyavlenie();
		},
		destroyed() {
			window.removeEventListener('resize', this.windowSize)
		},
		name: 'DeveloperRoom',
		components:{
			IconBase,
			IconImac,
			IconTable,
			IconBoard,
			IconLamp,
			IconCactus,
			IconHeadMan,
			IconSmoke,
			IconMoney,
			iconTea,
			IconFactory,
			IconCloud,
			IconPhone,
			IconAccounting,
			IconFile,
			IconArrow,
			IconClose,
			IconTap,
			City,
			iconTelephone,
			iconDollar,
			MaskedInput,
			RadioAnim
		},
		methods: {
			isTouchDevice() {
				if ("ontouchstart" in document.documentElement)
				{
					return true;
				}
				else
				{
					return false;
				}
			},
			killSmoke(){
				this.isHidden = false;
			},
			visibleLamp() {
				this.isHiddenLamp = true;
			},
			unvisible() {
				this.isHiddenLamp = false;
			},
      unvisibleButtonServ() {
			  this.$refs.bottomServices.style.dispay = 'none'
      },
			crashLamp() {
				this.$refs.lamp.crash();
			},
			visibleMoney(){
				this.money.hello();
				setTimeout(()=> this.moneyFrom = true, 500);
			},
			unvisibleMoney() {
				this.moneyFrom = false;
				this.money.bay();
			},
			visibleForm() {
				this.form = true;
			},
			unvisibleForm() {
				this.form = false;
			},
			crashTea() {
				this.killSmoke();
				this.tea.crash();
			},
			poyavlenie() {

				var tl = new TimelineLite();
				var Y = window.innerHeight * 700 / 969;
				var X = window.innerHeight * -200 / 969;

				tl.to('#icon__city', 0.75, { ease: Power2.easeIn, transformOrigin:"center", scale:1, y:0, x:0});
				tl.to('#icon__city', 2, { ease: Power2.easeIn, transformOrigin:"center", scale:60, y:-Y, x:-X});
				tl.to('#icon__city', 0.25, { ease: Power2.easeIn, transformOrigin:"center", scale:60, y:-Y, x:-X});
				tl.to('#icon__preloader', 0.4, {ease: Power2.easeIn, opacity:0}, '-=0.6');

				setTimeout(this.start, 2500);
				setTimeout(function () {
					this.$refs.icon__preloader.style.pointerEvents = "none";
					tl.kill();
					this.preloader = false;
				}.bind(this), 3000)
			},
			strelkaPlus() {
				this.cardAnimPauseAll();
				this.plus()
				this.cardAnimPlay();
			},
			strelkaMinus() {
				this.cardAnimPauseAll();
				this.minus()
				this.cardAnimPlay();
			},
			plus() {
				if (this.selected < 5) {
					this.selected += 1;
				}
				else {
					this.selected = 1;
				}
			},
			minus() {
				if (this.selected > 1) {
					this.selected -= 1;
				}
				else {
					this.selected = 5;
				}
			},
			visibleServices() {
				this.services = true;
				this.stop();
				this.cardAnimPlay();
			},
			keyUnvisibleServices(e) {
				if (e.key == 'Escape') {
					this.unvisibleServices();
				}
			},
			unvisibleServices() {
				this.services = false;
				this.start();
				this.cardAnimPauseAll();
				this.cardAnimStopAll();
			},
			cardMove(e) {
				if (e.pointerType === "touch") {
					this.cardAnimPause();
					if (e.center.x < this.leftGran) {
						TweenMax.to('#bounce--card', 0.8, {opacity: 0.25});
					}
					else if (e.center.x > this.rightGran) {
						TweenMax.to('#bounce--card', 0.8, {opacity: 0.25});
					}
					else {
						TweenMax.to('#bounce--card', 0.25, {opacity: 1});
					}
					var X = e.center.x - this.centerX;
					TweenMax.to('#bounce--card', 0.3, {x: X, transformOrigin: "end", rotation: X / 20, y: (X / 50) * (X / 50)});
				}
			},
			cardStart(e) {
				if (e.pointerType === "touch") {
					if (e.velocityX > 0.4) {
						this.cardExitRight();
					}
					else if (e.velocityX < -0.4) {
						this.cardExitLeft();
					}
					else {
						if (e.center.x > this.rightGran) {
							this.cardExitRight();
						}
						else if (e.center.x < this.leftGran) {
							this.cardExitLeft();
						}
						else {
							this.cardAnimPlay();
							TweenMax.to('#bounce--card', 0.75, {x: 0, y: 0, transformOrigin: "end", rotation: 0});
							TweenMax.to('#bounce--card', 0.25, {opacity: 1});
						}
					}
				}
				else {
					this.cardAnimPlay();
					TweenMax.to('#bounce--card', 0.75, {x: 0, y: 0, transformOrigin: "end", rotation: 0});
					TweenMax.to('#bounce--card', 0.25, {opacity: 1});
				}
			},
			cardExitRight() {
				this.cardAnimPauseAll();
				var tl = new TimelineLite();
				tl.to('#bounce--card', 0.5, {x: (this.rightGran - this.centerX) * 10, opacity:0 });
				tl.set('#bounce--card',{x: (this.rightGran - this.centerX) * 10 * (-1), opacity:1 })
				tl.to('#bounce--card', 0.3, {x: 0, y: 0, transformOrigin: "end", rotation: 0});

				setTimeout(this.plus, 50);
				setTimeout(this.cardAnimPlay, 700);
			},
			cardExitLeft() {
				this.cardAnimPauseAll();

				var tl = new TimelineLite();

				tl.to('#bounce--card', 0.5, {x: (this.rightGran - this.centerX) * 10 * (-1), opacity:0 });
				tl.set('#bounce--card',{x: (this.rightGran - this.centerX) * 10, opacity:1})
				tl.to('#bounce--card', 0.3, {x: 0, y: 0, transformOrigin: "end", rotation: 0});

				setTimeout(this.minus, 50);
				setTimeout(this.cardAnimPlay, 700);
			},
			cardAnimStartAll() {
				this.$refs.iconFactory.start();
				this.$refs.iconCloud.start();
				this.$refs.iconPhone.start();
				this.$refs.iconAcc.start();
				this.$refs.iconFile.start();
				this.$refs.iconTap.start();
			},
			cardAnimStopAll() {
				this.$refs.iconFactory.stop();
				this.$refs.iconCloud.stop();
				this.$refs.iconPhone.stop();
				this.$refs.iconAcc.stop();
				this.$refs.iconFile.stop();
				this.$refs.iconTap.stop();
			},
			cardAnimPause() {
				if (this.selected === 1) {
					this.$refs.iconFactory.pause();
				}
				else if (this.selected === 2) {
					this.$refs.iconCloud.pause();
				}
				else if (this.selected === 3) {
					this.$refs.iconPhone.pause();
				}
				else if (this.selected === 4) {
					this.$refs.iconAcc.pause();
				}
				else if (this.selected === 5) {
					this.$refs.iconFile.pause();
				}
			},
			cardAnimPauseAll() {
				this.$refs.iconFactory.pause();
				this.$refs.iconCloud.pause();
				this.$refs.iconPhone.pause();
				this.$refs.iconAcc.pause();
				this.$refs.iconFile.pause();
				this.$refs.iconTap.pause();
			},
			cardAnimPlay() {
				if (this.selected === 0) {
					this.$refs.iconTap.play();
				}
				if (this.selected === 1) {
					this.$refs.iconFactory.play();
				}
				else if (this.selected === 2) {
					this.$refs.iconCloud.play();
				}
				else if (this.selected === 3) {
					this.$refs.iconPhone.play();
				}
				else if (this.selected === 4) {
					this.$refs.iconAcc.play();
				}
				else if (this.selected === 5) {
					this.$refs.iconFile.play();
				}
			},
			windowSize() {
				this.widthDevice = window.innerWidth;
				this.heightDevice = window.innerHeight;

				this.centerX = this.widthDevice/2;
				this.leftGran = this.widthDevice * 0.05;
				this.rightGran = this.widthDevice - this.leftGran;

				if (this.isTouchDevice() && (this.widthDevice / this.heightDevice) > (16 / 11)) {
          this.$refs.mainBox.style.width = '161.5vh'
          this.reStyleModal()
        }
				else {
          this.$refs.mainBox.removeAttribute('style')
        }
			},
      reStyleModal() {
        this.$refs.services.style.justifyContent = 'start'
        this.$refs.servicesEl.style.marginTop = '2vh'
        this.$refs.formModal.style.alignItems = 'start'
        this.$refs.form.marginTop = '2vh'
      },
			stop() {
				this.head.stop();
				this.lamp.stop();
			},
			start() {
				this.lamp.start();
				this.head.start();
			},
      validateForm() {
        if (this.$v.formName.$error == false) {
          if (this.$v.formPhone.$error == false || this.$v.formEmail.$error == false){
            return true
          }
        }
        return false
      },
			onSumbit() {
				this.$v.$touch();
				if (this.validateForm()) {
				  let formUp = this.formUpload

					var bodyFormData = new FormData();

					bodyFormData.set('name', this.formName);
					bodyFormData.set('email', this.formEmail);
					bodyFormData.set('phone', this.formPhone);
					axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
					axios.post('/callback', bodyFormData)
            .then(function ({ data }) {
              if (data.error != 1) {
                formUp(true)
              }
              else {
                formUp(false)
              }
            })
            .catch((err) => {
              console.log(err)
              formUp(false)
            })
				}
			},
			formUpload(trueFalse) {
				if (trueFalse == true) {
					this.dataError = false
					this.dataSuccess = true
				}
				else if (trueFalse == false) {
					this.dataError = true
					this.dataSuccess = false
				}
			}
		},
		computed: {
			boolLamp() {
				return this.isHiddenLamp;
			},
      touchDevice() {
			  return this.isTouchDevice()
      }
		},
		validations: {
			formName:{
				required,
				maxLength: maxLength(30)
			},
			formEmail: {
				required,
				email
			},
			formPhone: {
				required,
				minLength: minLength(11)
			}
		}
	}
</script>

<style lang="scss">
	$color-back: #d4cbb9;
	$color-floor: #f2f2f2;
  $color-footer: #93c5c6;

	@font-face {
		font-family: 'Rubik';
		src: url('../resources/font/Rubik-Regular.ttf');
		font-style: normal;
	}

	@font-face {
		font-family: 'Russo';
		src: url('../resources/font/RussoOne-Regular.ttf');
		font-style: normal;
	}

	@function calcFluidFontSize($f-min, $f-max, $v-min, $v-max) {
		$k: ($f-max - $f-min)/($v-max - $v-min);
		$b: $f-min - $k * $v-min;

		$b: $b * 1px;

		@return calc( #{$k} * 100vw + #{$b} );
	}

	@keyframes button {
		from {
			background-color:#93c5c6;
			color: white;
		}
		to {
			background-color: white;
			color: #93a6c6;
		}
	}

	@keyframes yav {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	.bounce-enter-active {
		animation: yav 0.5s;
	}

	.bounce-leave {
		position: absolute;
		display: none;
		opacity: 0;
	}

	.bounce-leave-active {
		position: absolute;
		display: none;
		opacity: 0;
	}

	.box {
		width: 100%;
		padding-top: 37%;
		position: relative;

		&--content {
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
		}

		&--one {

		}

		&--two {
			z-index: 1;
		}

		&--three {

		}

	}

	.button {
		padding: 0.5vw 1vw;
		border-radius: 10px;
		margin-right: 1.5vw;
		margin-left: 1.5vw;

		&:hover {
			animation: button  0.15s 1 ease-in-out;
			background-color: white;
			color: #93a6c6;
		}
	}

	.contact {
		z-index: 10;
		background: linear-gradient(90deg, #93c5c6, #93a6c6 90%);
		height: auto;
		position: relative;

		&--button {
			-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		}

		&--man-child {
			width: 55%;
		}

		&--man {
			width: 20%;
			height: 25%;
			z-index: 1;
			float: left;
			shape-outside: circle(50%);
			margin-right: 3%;
			margin-left: 3%;
		}

		&--null {
			height: 6vw;
			pointer-events: none;
		}

		&-d-flex {
			display: flex;
			justify-content: space-between;
		}

		&--question {
			width: 100%;
			margin-top: 3vh;
			position: absolute;
		}

		&--circle {
			width: 16vw;
			height: 16vw;

			background-color: $color-footer;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;
			background: linear-gradient(0deg, #93c5c6 35%, #93a6c6);

		}

		&--group {
			position: absolute;
			width: 100%;
			top: -8vw;
		}

		&--text-top {
			padding-top: 2.5vw;
			padding-bottom: 2.5vw;
			padding-right: 1.5vw;
			padding-left: 1.5vw;
			background: linear-gradient(90deg, #93c5c6, #5470a1);
		}

		&--romb {
			border-radius: 50%;
		}

	}

	.d-flex {
		display: flex;

		&-j-c {
			justify-content: center;
		}

		&-j-b {
			justify-content: space-between;
		}

		&-j-a {
			justify-content: space-around;
		}

		&-column {
			flex-direction: column;
		}

		&--element-max {

		}

		&-a-s {
			align-items: stretch;
		}

		&-a-c {
			align-items: center;
		}
	}

	.img--logo {
		width: 100%;
		height: 100%;
	}

	.gluh {
		&--top {
			height: 70%;
		}
		&--bottom {
			height: 30%;
		}
	}

	.main {
    position: fixed;
    width: 100%;
		background-color: #d4cbb9;
		display: flex;
		flex-direction: column;
		height: 100%;
		overflow: hidden;
		font-family: 'Rubik', sans-serif;
		&-cursor-norm {
			cursor: url(../resources/cursor/hand.png), default;
		}
		&-cursor-point {
			cursor: url(../resources/cursor/tap.png), pointer;
		}
		&--back {
			background-color: #1E201D;
			position: absolute;
			width: 100vw;
			height: 100vh;
			z-index: 1;
		}
		&--box {
			width: calc(190vh * 0.95);
		}
		&--real {
			height: 100vh;
		}
		&--blur {
			filter: blur(5px);
		}
		&--content {
			z-index: 2;
		}
		&--contact {
			flex-grow: 1;
		}
		&--preloader {
			z-index: 200;
			position: fixed;
			background-color: #b0c8a7;
			width: 100vw;
			height: 100vh;
			display: flex;
			justify-content: center;
		}
		&--gluh {
			flex-grow: 1;
		}
		&--preloader-city {
			position: fixed;
			height: 100vh;
		}
	}

	.office {
		height: 100%;

		&--avatar {
			top: 13%;
			right: 3%;
			width: 18%;
		}

		&--avatar-child {
			width: 100%;
			-webkit-filter: contrast(1.05);
			filter: contrast(1.05);
		}

		&--bottom {
			height: 30%;
			width: 100%;
		}

		&--board {
			top: 15%;
			left: 2%;
			width: 25%;
		}

		&--radio {
			left: 40%;
			top: 69%;
			width: 4%;
		}

		&-color-white {
			background-color: $color-floor;
		}

		&-color-bright {
			background: linear-gradient(180deg, #d4cbb9, #c2b9a9);
		}

		&--cactus {
			width: 50%;
			right: -13%;
			top: 50%;
		}

		&--money {
			width: 25%;
			pointer-events: none;
		}

		&--element {
			outline: none !important;
			user-select: none !important;
			-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		}

		&--element-width-100 {
			width: 100%;
		}

		&--element-width-75 {
			width: 100%;
		}

		&--element-width-50 {
			width: 100%;
		}

		&--element-width-25 {
			width: 100%;
		}

		&-flex-center {
			display: flex;
			justify-content: center;
		}

		&--logo {
			width: 15%;
			height: 15%;
			top: 4%;
			left: 7%;
		}

		&--lamp {
			z-index: 1;
			transform: translateY(-1%);
			width: 70vh;
			pointer-events: none;
		}

		&--monitor {
			top: 44%;
			width: 10%;
			left: 5%;
		}

		&-main-1 {
			z-index: 1;
		}

		&-main-2 {
			z-index: 2;
		}

		&-main-3 {
			z-index: 3;
		}

		&-main-4 {
			z-index: 4;
		}

		&-main-5 {
			z-index: 5;
		}

		&-main-6 {
			z-index: 6;
		}

		&-main-7 {
			z-index: 7;
		}

		&-main-100 {
			z-index: 100;
		}

		&--nasadkalamp {
			width: 6%;
			height: 20%;
			z-index: 2;
		}

		&-pos-abs {
			position: absolute;
		}

		&-pos-abs-center {
			left: 50%;
			transform: translateX(-50%);
		}

		&-pos-rel {
			position: relative;
		}

		&--pause {
			width: 25px;
		}

		&--play {
			width: 25px;
		}

		&--smoke {
			left: 55.5%;
			top: 55%;
			width: 3%;
		}

		&--top {
			height: 70%;
			width: 100%;
			position: relative;
		}

		&--table {
			width: 23%;
			top: 82%;
		}

		&--tea {
			top: 59%;
			width: 8%;
			left: 53.5%;
		}

	}

	.services{
		z-index: 200;
		position: fixed;
		width: 100vw;
		height: 100vh;
		user-select: none;

    &--bottom {
      display: none;
    }

		&--element {
			border-radius: 3%;
			width: 35vw;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}

		&--element-none {
			display: none;
		}

		&--iconFactory {
			margin-top: 1%;
			width: 100%;
		}

		&--iconCloud {
			margin-top: 10%;
			width: 50%;
		}

		&--iconTap {
			width: 50%;
		}

		&--strelka {
			outline: none;
			z-index: 100;
			padding: 2vw;
			width: 2vw;
			height: 2vw;
			background-color: #F2F2F2;
			border-radius: 50%;
			box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
			display: flex;
			align-items: center;
			justify-content: center;
			&:hover {
				background-color: #dcdcdc;
			}
			margin-left: 3vw;
			margin-right: 3vw;
		}

		&--text {
			width: 70%;
			margin-top: 15%;
			margin-bottom: 10%;
		}

		&--novisi {
			opacity: 0;
		}


		&--close {
			outline: none;
			margin-top: 3%;
			transform: translateX(15vw);
			width: 2vw;
			&:hover {
				color: #e97451;
			}
		}

		&-theme-color-base {
			background-color: #F2F2F2;
			box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
		}

		&--right {
			transform: rotate(180deg);
		}

	}

	.text {

		&-color-white {
			color: white;
		}

		&-size-s {
			font-size: 1vw;
		}

		&-size-m {
			font-size: 1.4vw;
		}

		&-size-l {
			font-size: 1.8vw;
		}

		&-size-xxl {
			font-size: calcFluidFontSize(35, 50, 480, 1280);
		}

		&-align-center {
			text-align: center;
		}

		&-align-start {
			text-align: start;
		}

		&-align-end {
			text-align: end;
		}

		&-type-big {
			font-family: 'Russo', sans-serif;
		}

		&-type-standart {
			font-family: 'Rubik', sans-serif;
		}

	}

	.form {

		&--banner {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 10%;
			margin-bottom: 10%;
		}

		&--icon {
			width: 30%;
		}

		&--text {
			width: 50%;
		}

		&--input {
			padding: 0.5em 0.75em 0.5em 0.75em;
			border: none;
			border-radius: 0%;
			background-color: $color-floor;
			border: 0.09em solid $color-footer;
			color: #1e201d;
			width: 91%;

			&:focus {
				outline: none;
			}
			&:focus ~ label,
			&:valid ~ label {
				top: -25%;
				font-size: 1.2vw;
				color: #7f7679;
				background-color: $color-floor;
				padding-left: 3%;
				padding-right: 3%;
			}
			&:focus ~ .bar:before {
				width: 100%
			}
		}

		&--label {
			color: #424242;
			font-weight: normal;
			position: absolute;
			pointer-events: none;
			left: 5%;
			top: 25%;
			transition: 300ms ease all;
		}

		&--group {
			position: relative;
			width: 70%;
			margin-top: 4%;
			margin-bottom: 4%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}

		&--button {
			margin-top: 1em;
			margin-bottom: 1em;
			padding: 0.5em 0.75em 0.5em 0.75em;
			border: none;
			color: white;
			background-color: #fc5b3f;
			border-radius: 0.25em;

			&:hover {
				background-color: #d12304;
			}

		}

		&--error {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			justify-content: center;
			color: #fc5b3f;
			position: absolute;
			top: 100%;
		}

		&--labelError {
			margin-top: 1%;
			margin-bottom: 1%;
		}

	}

	.bar {
		position: relative;
		display: block;
		width: 100%;

		&-error {
			position: relative;
			display: block;
			width: 100%;
			&:before {
				background: #fc5b3f;
				content: '';
				height: 0.2em;
				width: 0;
				bottom: 0px;
				position: absolute;
				transition: 300ms ease all;
				left: 0%;
			}
		}

		&-success {
			&:before {
				background: #228b22;
				content: '';
				height: 0.2em;
				width: 0;
				bottom: 0px;
				position: absolute;
				transition: 300ms ease all;
				left: 0%;
			}
		}
	}

	@media  (min-aspect-ratio: 1/16) and (max-aspect-ratio: 11/16) {
		.box{
			padding-top: 100%;
		}

		.button {
			padding: 1.5vw 2vw;
		}

		.contact {

			&--group {
				top: -6vw;
			}

			&--romb {
				width: 21vw;
				height: 21vw;
				position: absolute;
				top: 42vw;
				right: -7vw;
				background-color:#93a6c6 ;
			}

			&--man {
				width: 35%;
				height: 35%;
				z-index: 1;
				display: flex;
				justify-content: center;
			}

			&-d-flex {
				flex-direction: column;
				align-items: center;
			}

			&--question {
				width: 100%;
				margin-top: 4vw;
				position: relative;
			}

			&--circle {
				width: 35vw;
				height: 35vw;
			}

			&--text {
				z-index: 1;
				margin-left: 3%;
				margin-right: 3%;
				margin-top: 4%;
				margin-bottom: 4%;
			}

			&--null {
				height: 5vw;
			}

			&--text-top {
				padding-left: 18%;
			}

		}

		.office {

			&--monitor {
				top: 60%;
				width: 25%;
			}

			&--money {
				width: 60%;
			}

			&--tea {
				top: 78%;
				width: 16%;
				left: 58.5%;
			}

			&--logo {
				width: 30%;
				left: 11%;
				top: 9%;
			}

			&--smoke {
				top: 78%;
				left: 63.5%;
				width: 4.5%;
			}

			&--board {
				top: 19%;
				width: 43%;
				left: 5%;
			}

			&--radio {
				width: 12%;
				left: 26%;
				top: 81%;
			}

			&--avatar {
				width: 40%;
				right: 5%;
				top: 10%;
			}

			&--table {
				top: 95%;
				width: 50%;
			}

			&--lamp {
				width: 160%;
			}

			&--cactus {
				left: 38%;
				top: 65%;
				width: 100%;
			}

			&--nasadkalamp {
				width: 20%;
				height: 23%;
			}

		}

		.services {

      &--phoneNone {
        display: none;
      }

      &--top {
        height: 120vw;
      }

      &--bottom {
        display: flex;
      }

			&--element {
				width: 95vw;
			}

      &--strelka {
        width: 8vw;
        height: 8vw;
        margin-left: 15vw;
        margin-right: 15vw;
      }

			&--close {
				transform: translateX(40vw);
				width: 8vw;
			}

		}

		.main {
			&--box {
				width: calc(70vh * 0.65);
			}
		}

		.text {

			&-size-s {
				font-size: 2.5vw;
			}

			&-size-m {
				font-size: 4vw;
			}

			&-size-l {
				font-size: 5vw;
			}

			&-size-xxl {
				font-size: calcFluidFontSize(35, 50, 480, 1280);
			}
		}

		.form{
			&--input {

				&:focus ~ label,
				&:valid ~ label {
					top: -19%;
					font-size: 3vw;
					color: #424242;
					background-color: $color-floor;
					padding-left: 3%;
					padding-right: 3%;
				}
			}
		}
	}

	@media (max-width: 420px ) and (min-height: 800px) {

		.box{
			padding-top: 120%;
		}

		.office {
			&--monitor {
				top: 66%;
			}

			&--radio {
				top: 83%;
			}

			&--tea {
				top: 82%;
			}

			&--smoke {
				top: 81%;
			}
		}

	}

	@media (min-aspect-ratio: 11/16) and (max-aspect-ratio: 15/16) {
		.box{
			padding-top: 70%;
		}

		.button {
			padding: 1.5vw 2vw;
		}

		.contact {

			&--group {
				top: -6vw;
			}

			&--romb {
				width: 21vw;
				height: 21vw;
				position: absolute;
				top: 42vw;
				right: -7vw;
				background-color:#93a6c6 ;
			}

			&--man {
				width: 30vw;
				height: 30vw;
				z-index: 1;
				display: flex;
				justify-content: center;
			}

			&-d-flex {
				flex-direction: column;
				align-items: center;
			}

			&--question {
				width: 100%;
				margin-top: 4vw;
				position: relative;
			}

			&--circle {
				width: 28vw;
				height: 28vw;
			}

			&--text {
				z-index: 1;
				margin-left: 3%;
				margin-right: 3%;
				margin-top: 4%;
				margin-bottom: 4%;
			}

			&--null {
				height: 5vw;
			}

			&--text-top {
				padding-left: 18%;
			}

		}

		.office {

			&--monitor {
				top: 60.7%;
				width: 17%;
			}

			&--money {
				width: 60%;
			}

			&--tea {
				top: 76%;
				width: 13%;
				left: 56%;
			}

			&--logo {
				width: 25%;
				left: 9%;
				top: 9%;
			}

			&--smoke {
				top: 72%;
				left: 60%;
				width: 4.5%;
			}

			&--board {
				top: 19%;
				width: 33%;
				left: 5%;
			}

			&--radio {
				width: 10%;
				left: 31%;
				top: 79%;
			}

			&--avatar {
				width: 30%;
				right: 5%;
				top: 10%;
			}

			&--table {
				top: 95%;
				width: 40%;
			}

			&--lamp {
				width: 100%;
			}

			&--cactus {
				left: 40%;
				top: 55%;
				width: 80%;
			}

			&--nasadkalamp {
				width: 20%;
				height: 23%;
			}

		}

		.services {

      &--top {
        height: 95vw;
      }

      &--bottom {
        display: flex;
      }

      &--strelka {
        width: 5vw;
        height: 5vw;
        margin-left: 15vw;
        margin-right: 15vw;
      }

      &--phoneNone {
        display: none;
      }

			&--element {
				width: 75vw;
			}

			&--close {
				transform: translateX(32vw);
				width: 8vw;
			}

		}

		.main {
			&--box {
				width: calc(110vh * 0.65);
			}
		}

		.form{
			&--input {

				&:focus ~ label,
				&:valid ~ label {
					top: -19%;
					font-size: 2.5vw;
					color: #424242;
					background-color: $color-floor;
					padding-left: 3%;
					padding-right: 3%;
				}
			}
		}

		.text {

			&-size-s {
				font-size: 2vw;
			}

			&-size-m {
				font-size: 3vw;
			}

			&-size-l {
				font-size: 4vw;
			}

			&-size-xxl {
				font-size: calcFluidFontSize(35, 50, 480, 1280);
			}
		}
	}

	@media (min-aspect-ratio: 15/16) and (max-aspect-ratio: 16/11) {
		.box{
			padding-top: 50%;
		}

		.button {
			padding: 1.5vw 2vw;
		}

		.contact {

			&--group {
				top: -6vw;
			}

			&--romb {
				width: 21vw;
				height: 21vw;
				position: absolute;
				top: 42vw;
				right: -7vw;
				background-color:#93a6c6 ;
			}

			&--man {
				width: 20vw;
				height: 20vw;
				z-index: 1;
				display: flex;
				justify-content: center;
			}

			&--circle {
				width: 20vw;
				height: 20vw;

			}

			&-d-flex {
				flex-direction: column;
				align-items: center;
			}

			&--question {
				width: 100%;
				margin-top: 4vw;
				position: relative;
			}


			&--text {
				z-index: 1;
				margin-left: 3%;
				margin-right: 3%;
				margin-top: 4%;
				margin-bottom: 4%;
			}

			&--null {
				height: 5vw;
			}

			&--text-top {
				padding-left: 18%;
			}

		}

		.office {

			&--monitor {
				top: 53%;
				width: 15%;
			}

			&--money {
				width: 60%;
			}

			&--tea {
				top: 74%;
				width: 10%;
				left: 55%;
			}

			&--logo {
				width: 18%;
				left: 9%;
				top: 9%;
			}

			&--smoke {
				top: 68%;
				left: 57.5%;
				width: 4%;
			}

			&--board {
				top: 19%;
				width: 27%;
				left: 5%;
			}

			&--radio {
				width: 5%;
				left: 36.5%;
				top: 83%;
			}

			&--avatar {
				width: 25%;
				right: 5%;
				top: 10%;
			}

			&--table {
				top: 95%;
				width: 30%;
			}

			&--lamp {
				width: 60%;
			}

			&--cactus {
				left: 53%;
				top: 60%;
				width: 60%;
			}

			&--nasadkalamp {
				width: 20%;
				height: 23%;
			}

		}

		.main {
			&--box {
				width: calc(115vh * 0.95);
			}
		}

		.services {

			&--element {
				width: 45vw;
			}

			&--strelka {
				display: block;
			}


			&--close {
				transform: translateX(20vw);
				width: 3vw;
			}

		}

		.text {

			&-size-s {
				font-size: 1.4vw;
			}

			&-size-m {
				font-size: 2vw;
			}

			&-size-l {
				font-size: 2.5vw;
			}

			&-size-xxl {
				font-size: calcFluidFontSize(35, 50, 480, 1280);
			}
		}

		.form{
			&--input {

				&:focus ~ label,
				&:valid ~ label {
					top: -19%;
					font-size: 1.5vw;
					color: #424242;
					background-color: $color-floor;
					padding-left: 3%;
					padding-right: 3%;
				}
			}
		}
	}

	@media (min-aspect-ratio: 160/70) {
		.services{

			&--iconCloud {
				margin-top: 6%;
				height: 10%;
			}
			&--text {
				width: 70%;
				margin-top: 5%;
				margin-bottom: 5%;
			}

		}

		.text {
			&-size-l {
				font-size: 5vh;
			}
		}

		.form {

			&--icon {
				display: none;
			}

			&--banner {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 2%;
				margin-bottom: 2%;
			}


			&--group {
				margin-top: 2%;
				margin-bottom: 3%;
			}


		}
	}

	@media (min-aspect-ratio: 16/11) {
		.office {
			&--cactus {
				z-index: 100;
			}
		}
	}
</style>
